import styled from "styled-components";
import { FlexColumn } from "styles/layout";
import { Theme } from "theme";

export const MatchTimeContainer = styled(FlexColumn)<{ isDelayed: boolean }>`
  width: 40px;
  padding-left: 5px;
  text-align: right;
  font-size: 10pt;
  margin-left: auto;

  ${({ isDelayed }) =>
    isDelayed && `color: ${Theme.matchStatusDelayedForeground}`}
`;
